<template>
  <div>
    <!-- TitleコンポーネントとErrorMessageコンポーネントを読み込み、必要な引数を渡している -->
    <Title title="各種設定" description="運営からお知らせがあった際の通知方法を設定します。" />
    <ErrorMessage :status="apiStatus.status" :customMessage="apiStatus.customMessage" />

    <!-- apiからデータを読み込んだらこちらを表示 -->
    <template v-if="apiStatus.status !== 0">
      <!-- 現在の設定の表示-->
      <config
        v-bind:notice="configAnnouncementNoticeType"
        v-bind:emails="configNoticeEmailList"
        @update="update()"
      ></config>
    </template>
    <!-- apiからデータを読み込むまではErrorMessageで「データの読み込み中です。」を表示 -->
  </div>
</template>

<script>
//  使いたいコンポーネントを読み込む
import { mapState } from 'vuex'
import Title from '@/components/Title.vue'
import ErrorMessage from '@/components/ErrorMessage.vue'
import Config from '@/components/Config.vue'
import { getErrorStatus } from '@/transformer/base'

export default {
  name: 'Configs',

  // 使用するコンポーネントを追加
  components: {
    Title,
    ErrorMessage,
    Config
  },

  //  コンポーネントに持たせたい変数と初期値を設定
  data: function () {
    return {
      status: [
        { value: 0, text: 'メールで通知しない' },
        { value: 1, text: 'メールで通知する' }
      ],
      configAnnouncementNoticeType: [],
      configNoticeEmailList: [],
      apiStatus: {
        status: 0,
        custumMessage: ''
      }
    }
  },

  //  関数や加工が必要な表示用テキスト。
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth.isLoggedIn
    })
  },

  // 関数
  methods: {
    update: function () {
      // apiを呼び出す
      this.$axios
        .get(this.$constList.apiUrl + 'config/list')
        .then((res) => {
          // ここで取得したデータを変数に入れる
          if (this.apiStatus.status === 0 || res.status !== 200) {
            this.apiStatus.status = res.status
          }
          this.configAnnouncementNoticeType = res.data.announcement_notice_type
          this.configNoticeEmailList = res.data.notice_email_list
        })
        .catch((error) => {
          this.apiStatus = getErrorStatus(error)
        })
    }
  },

  // ページが読み込まれたときに行う処理
  mounted: function () {
    this.update()
  }
}
</script>
